module.exports = __webpack_public_path__ + "static/media/graanul.e227c17a.svg";